import Dashboard from "./Dashboard";
import { useOrderAlerts } from "../components/OrderAlertsProvider";
import { dashboardUrlFor, useActiveRestaurantId } from "../utils/activeRestaurant";

/**
 * Çok restoranlı hesapta Dashboard'un üstündeki restoran şeridi. Diğer restoranların
 * siparişlerini dinlemek ve uyarı göstermek uygulama genelindeki OrderAlertsProvider'ın işi;
 * burası yalnız seçimi ve rozetleri gösterir. Tek restoranlı hesapta şerit hiç görünmez.
 */
export default function MultiRestaurantDashboard() {
  const activeId = useActiveRestaurantId();
  const { restaurants, pending, goToRestaurant } = useOrderAlerts();
  const multi = restaurants.length > 1;

  return (
    <>
      {multi && (
        <div className="mr-bar">
          <div className="mr-bar__label"><i className="bi bi-shop me-2"></i>Restoranlarım</div>
          <div className="mr-bar__list" role="tablist">
            {restaurants.map((r) => {
              const active = r.id.toLowerCase() === activeId.toLowerCase();
              const count = active ? 0 : pending[r.id] ?? 0;
              return (
                <div key={r.id} className={`mr-chip${active ? " mr-chip--active" : ""}${count > 0 ? " mr-chip--alert" : ""}`}>
                  <button type="button" className="mr-chip__main" role="tab" aria-selected={active}
                    onClick={() => !active && goToRestaurant(r.id)}
                    title={active ? "Şu an bu restorana bakıyorsunuz" : `${r.name} dashboard'una geç`}>
                    <span className={`mr-chip__dot${r.isOpenNow ? " mr-chip__dot--open" : ""}`}
                      title={r.isOpenNow ? "Şu an açık" : "Şu an kapalı"} />
                    <span className="mr-chip__name">{r.name}</span>
                    {count > 0 && <span className="mr-chip__badge">{count}</span>}
                  </button>
                  <a className="mr-chip__newtab" href={dashboardUrlFor(r.id)} target="_blank" rel="noopener noreferrer"
                    title={`${r.name} dashboard'unu yeni sekmede aç`} aria-label={`${r.name} yeni sekmede aç`}>
                    <i className="bi bi-box-arrow-up-right"></i>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Restoran değişince Dashboard baştan kurulur: bütün yüklemeler yeni restoranla çalışır */}
      <Dashboard key={activeId} />
    </>
  );
}
